












import { Component, Mixins } from 'vue-property-decorator'
import { LibraryMixin } from '../../../../mixins'

@Component({})
export default class LibraryBar extends Mixins(LibraryMixin) {
  get uploadTypeLabel(): string {
    return this.library.isPartialImport ? 'Playlist Upload' : 'Full Upload'
  }

  get importTypeLabel(): string {
    return this.dvsName
  }

  get uploadTypeTooltip(): string {
    return this.library.isPartialImport ? 'Your last upload was a selection of playlists' : 'Your last upload was your entire library'
  }

  get importTypeTooltip(): string {
    return `Your last upload came from ${this.importTypeLabel}`
  }
}
